import Highcharts from 'highcharts';
import {
  SHORT_MONTHS,
  FULL_MONTHS,
  FULL_WEEKDAYS
} from '@/common/constants/time.constants';

export default function setHighchartsLocale() {
  Highcharts.setOptions({
    lang: {
      shortMonths: Object.values(SHORT_MONTHS),
      months: Object.values(FULL_MONTHS),
      weekdays: Object.values(FULL_WEEKDAYS),
    }
  });
}
